import { OnInit, Component } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { DatePipe } from '@angular/common';

import { NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import { HttpErrorResponse } from '@angular/common/http';

import { GlobalComponent, Ordine, Result } from '../../environments/global';

@Component({
    selector: 'app-data',
    templateUrl: 'tempo.component.html',
    styleUrls: ['tempo.component.scss'],
    providers: [DatePipe]
})
export class TempoComponent implements OnInit {
    dateH: Date = new Date();
    dateString: String = this.dateH.toISOString().substring(0, 10);
    numH: string = '0';
    isLoading: boolean = false;
    ordine: Ordine;

    // ################################################
    // CLASS: CONSTRUCTOR
    public constructor(
        private router: Router,
        public g: GlobalComponent,
        private notification: NzNotificationService,
        private datepipe: DatePipe,
        private message: NzMessageService
    ) { }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {

        const snapshot: RouterStateSnapshot = this.router.routerState.snapshot;
        const params: any = snapshot.root.queryParams;

        if (typeof params.orderid === 'undefined') {
            this.router.navigateByUrl('/track/(trackContent:ordine)');
            return;
        }
        const orderId: number = +params.orderid;

        Object.keys(this.g.userData.ordini).forEach(key => {
            if (this.g.userData.ordini[key].id === orderId) {
                this.ordine = this.g.userData.ordini[key];
                return true;
            }
        });

        if (typeof this.ordine.id === 'undefined') {
            this.router.navigateByUrl('/track/(trackContent:ordine)');
            return;
        }

        this.g.trackTitle = '<i nz-icon nzType="file-text"></i> ' + this.ordine.title;

        if (this.ordine.date) {
            this.dateH = new Date(this.ordine.date);
            this.dateString = this.dateH.toISOString().substring(0, 10);
        }
        if (this.ordine.h) {
            this.numH = this.ordine.h.toString();
        }
    }

    public addNumber(strNum: string) {
        if (strNum === '.') {
            if (this.numH.indexOf('.') < 0) {
                this.numH += '.';
            }
        } else if (Number(this.numH) < 99) {
            const dec = this.numH.indexOf('.');

            if (dec > 0) {
                if (this.numH.length - 1 === dec) {
                    this.numH += strNum;
                }
            } else if (this.numH !== '0') {
                this.numH += strNum;
            } else if (strNum !== '0') {
                this.numH = strNum;
            }
        }
    }

    public clearNumber() {
        this.numH = '0';
    }

    public changeDate(n: number) {
        this.dateH.setDate(this.dateH.getDate() + n);
        this.dateString = this.dateH.toISOString().substring(0, 10);
    }
    public todayDate() {
        this.dateH = new Date();
        this.dateString = this.dateH.toISOString().substring(0, 10);
    }

    public addH() {
        let query: string;
        let msg: string;

        if (this.ordine.h) {
            this.numH = this.numH.replace(',', '.');
            query = 'UPDATE chk_times SET `h`="' + this.numH + '",' +
                '`date`="' + this.datepipe.transform(this.dateH, 'yyyy-MM-dd') + '" WHERE ' +
                '`userId`=' + this.g.userData.id + ' AND ' +
                '`orderId`=' + this.ordine.id + ' AND ' +
                '`date`="' + this.datepipe.transform(this.ordine.date, 'yyyy-MM-dd') + '"';
            msg = 'Modifica effettuata con successo!';
        } else {
            query = 'INSERT INTO chk_times (`id`, `date`, `userid`, `orderid`, `h`) VALUES ("' +
                this.datepipe.transform(this.dateH, 'yyyyMMddHHmmss') + '",' +
                '"' + this.datepipe.transform(this.dateH, 'yyyy-MM-dd') + '",' +
                '"' + this.g.userData.id + '",' +
                '"' + this.ordine.id + '",' +
                + this.numH + ')';
            msg = 'Nuovo inserimento creato con successo!';
        }
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                if (res.error === false) {
                    this.ordine.date = this.dateH;
                    this.ordine.h = Number(this.numH);

                    this.message.success(msg);
                    this.router.navigateByUrl('/track/(trackContent:ordine)');
                } else {
                    this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                    console.log(res);
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
            });
    }
    public removeH() {
        if (this.ordine.h) {
            const query: string = 'DELETE FROM chk_times WHERE ' +
                '`userId`=' + this.g.userData.id + ' AND ' +
                '`orderId`=' + this.ordine.id + ' AND ' +
                '`date`="' + this.datepipe.transform(this.ordine.date, 'yyyy-MM-dd') + '"';
            this.isLoading = true;
            this.g.mysql(query)
                .subscribe((res: Result) => {
                    this.isLoading = false;
                    if (res.error === false) {
                        this.ordine.date = null;
                        this.ordine.h = null;

                        this.message.success('Cancellazione effettua con successo!');
                        this.router.navigateByUrl('/track/(trackContent:ordine)');
                    } else {
                        this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                        console.log(res);
                    }
                }, (error: HttpErrorResponse) => {
                    this.isLoading = false;
                    this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
                });
        } else {
            this.router.navigateByUrl('/track/(trackContent:ordine)');
        }
    }
}
